import {get,post} from '../utils/request'

// 学生登陆
export const studentLogin = (data) =>post('/api/login/student',data)
// 家长登陆
export const paramsLogin = (data) => post('/api/login/studentParent',data)
// 获取验证码
export const codeNum = (params) => get('/api//sms/verifyCode',params)
// 教师登陆
export const teacherLogin = (data) => post('/api/login/teacher',data)
// 校领导登陆
export const schoolLeaderLogin = (data) => post('/api/login/leader/school',data)
// 区领导登陆
export const regionLeaderLogin = (data) => post('/api/login/leader/region',data)
// 管理员登陆
export const adminLogin = (data) => post('/api/login/admin',data)



// WEBPACK FOOTER //
// ./src/api/loginApi.js